module.exports = "<h1>MiDAS administration home</h1>\n<p>You're logged in, welcome to the MiDAS administrator homepage</p>\n"